<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NPNiJX/images/cover.jpg?1705667990496" alt="This image is the cover for the book Soviet Cold War Weaponry, Modern Warfare"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Soviet Cold War Weaponry, Modern Warfare
      </h1>
      <p class="bookDescription body article font2">
        <p>The T-54, T-62 and T-72 main battle tanks along with the personnel carriers, assault guns, self-propelled guns and anti-tank missiles that are illustrated in this photographic history represent the high point in the design and manufacture of armoured vehicles by the Soviet Union during the Cold War. Although the superpowers never came to blows, the 'Cold War' was far from cold, as numerous 'hot' proxy wars were fought in Africa and the Middle East, and these conflicts employed the Soviet weaponry that is shown in action in the colour and black-and-white photographs selected for this book.Between the 1950s and 1980s Soviet and Warsaw Pact countries produced thousands of tanks and armoured vehicles ready for the Third World War. They embarked on a technological arms race with the NATO allies in an attempt to counter each new piece of equipment as it appeared in service. Much of this Soviet weaponry has achieved almost iconic status and, despite its age, remains in service with armies, guerrilla forces and terrorist organizations around the world today. It is also of enduring interest to collectors, re-enactors and modellers who are fascinated by the military equipment of the late twentieth century.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anthony Tucker-Jones
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a93a247